<nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
  <nz-card [nzBordered]="false" style="max-width: 1000px; margin: auto;">
    <nz-descriptions nzTitle="General Info" [nzColumn]="2" nzBordered>
      <nz-descriptions-item nzTitle="Invoice #" [nzSpan]="1">{{ invoice?.invoice_number }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Status" [nzSpan]="1">
        <nz-tag [nzColor]="getStatusTagColor(invoice?.status)">
          {{ invoice?.status | uppercase }}
        </nz-tag>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Issue Date">{{ invoice?.issue_date | date: 'dd/MM/yyyy' }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Due Date">{{ invoice?.due_date | date: 'dd/MM/yyyy' }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Total Amount">{{ invoice?.total_amount | currency }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Currency">{{ invoice?.currency_type_details?.symbol }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Created By">{{ invoice?.created_by_name }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Modified By">{{ invoice?.modified_by_name }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Created At">{{ invoice?.created_at | date: 'dd/MM/yyyy' }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Modified At">{{ invoice?.modified_at | date: 'dd/MM/yyyy' }}</nz-descriptions-item>
    </nz-descriptions>

    <nz-divider>Linked Entities</nz-divider>
    <nz-descriptions [nzColumn]="2" nzBordered nzTitle="Linked Entities">
      <nz-descriptions-item nzTitle="Vendor">{{ invoice?.vendor_details?.name }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Event">{{ invoice?.event_details?.name }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Quotation Request">{{ invoice?.quotation_request_details?.request_title
        }}</nz-descriptions-item>
    </nz-descriptions>

    <nz-divider>Description</nz-divider>
    <nz-descriptions [nzColumn]="2" nzBordered nzTitle="Description">
      <nz-descriptions-item nzTitle="Description">{{ invoice?.description || 'No description provided.'
        }}</nz-descriptions-item>
    </nz-descriptions>
    <nz-divider>Files</nz-divider>

    <nz-table [nzData]="invoice?.file_details" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="false">
      <thead>
        <tr>
          <th>Filename</th>
          <th>Download</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of invoice?.file_details">
          <td>{{ getFileName(file?.file_url) }}</td>
          <td>
            <a (click)="handleDownload(file?.file_url, getFileName(file?.file_url))" nz-button nzType="link">
              <i nz-icon nzType="download"></i> Download
            </a>
          </td>
        </tr>
      </tbody>
    </nz-table>

  </nz-card>
</nz-spin>